import { ROUTES, getButtonLinkProps } from '@openclassrooms/routing';
import { translate } from '@openclassrooms/translations';
import { ImageCdn } from '@openclassrooms/images-cdn';
import { styled } from '@classify/react-core-components/styles';
import Stack from '@classify/react-core-components/Stack';
import Button from '@classify/react-core-components/Button';
import Box from '@classify/react-core-components/Box';
import Typography from '@classify/react-core-components/Typography';
import BulletPoint from '@classify/react-core-components/BulletPoint';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';

import imgSrc from '../../images/jobposting_ai_image.png';

import ToolIcon from '../ToolIcon';

const BulletList = styled('ul')(({ theme: { spacing } }) => ({
  margin: 0,
  padding: 0,
  '& > li': {
    display: 'flex',
    margin: 0,
    '&:not(:last-child)': {
      marginBottom: spacing(2),
    },
  },
}));

const AiBorder = styled('div')(({ theme: { spacing, palette } }) => {
  const bgColor = palette.layout.background.alternative;
  return {
    containerType: 'inline-size',
    background: `linear-gradient(${bgColor}, ${bgColor}) padding-box, ${palette.brand.gradient.pinkViolet} border-box`,
    border: `4px solid transparent`,
    borderRadius: spacing(1),
  };
});

const ImageContainer = styled('div')(({ theme: { containerQueries } }) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  justifyContent: 'center',
  '> img': {
    width: 300,
    alignSelf: 'center',
  },

  [containerQueries.up('sm')]: {
    flexDirection: 'row',
    '> img': {
      width: 400,
      alignSelf: 'flex-end',
    },
  },
  [containerQueries.up('md')]: {
    '> img': {
      width: 500,
      height: 'fit-content',
    },
  },
}));

const InnerWrapper = styled('div')(({ theme: { containerQueries } }) => ({
  display: 'flex',
  flexDirection: 'column',
  [containerQueries.up('sm')]: {
    flexDirection: 'row',
  },
}));

export default function JobOfferBanner() {
  return (
    <AiBorder>
      <InnerWrapper>
        <Box sx={{ flexGrow: 1, padding: { xs: 2, md: 4 } }}>
          <Typography variant="h4" sx={{ mb: 2 }}>
            {translate('job_market_place.offer_service.title')}
          </Typography>

          <BulletList>
            <BulletPoint marker={AutoAwesomeIcon}>
              {translate('job_market_place.apprenticeship.uvp_ai.bullet')}
            </BulletPoint>
            <BulletPoint marker={ToolIcon}>
              {translate('job_market_place.apprenticeship.uvp_tool.bullet')}
            </BulletPoint>
            <BulletPoint marker={ListAltRoundedIcon}>
              {translate('job_market_place.apprenticeship.uvp_offers.bullet')}
            </BulletPoint>
          </BulletList>

          <Stack direction="row" gap={2} sx={{ marginTop: 3 }}>
            <Button
              {...getButtonLinkProps(`${ROUTES.JOB_POSTINGS.INDEX}/apprenticeship`)}
              variant="secondary"
              data-event="Navigation|Redirection::Internal|Job offers preview access"
            >
              {translate('global.see_job_offers.cta')}
            </Button>

            <Button
              {...getButtonLinkProps(ROUTES.PATH.INDEX)}
              variant="tertiary"
              data-event="Navigation|Redirection::Internal|Discover trainings"
            >
              {translate('compare_offers.header.path.action')}
            </Button>
          </Stack>
        </Box>
        <ImageContainer>
          <ImageCdn src={imgSrc} width={500} />
        </ImageContainer>
      </InnerWrapper>
    </AiBorder>
  );
}
